import { defineMessages } from "react-intl";

export const extensionConfigMessages = defineMessages({
  configure: {
    id: '48vM30',
    defaultMessage: "Configure",
    description: "button to configure an extension",
  },
  active: {
    id: '4zX4I6',
    defaultMessage: "Active",
    description: "badge label for active extension",
  },
  inactive: {
    id: '3O+rwO',
    defaultMessage: "Inactive",
    description: "badge label for inactive extension",
  },
  noExtensions: {
    id: 'UclqIS',
    defaultMessage: "No supported extensions are installed.",
    description: "empty state text",
  },
  backToList: {
    id: 'Yfoqvb',
    defaultMessage: "← Back to list",
    description: "button to go back from config to list",
  },
  iframeError: {
    id: 'tMc+as',
    defaultMessage: "Failed to load app configuration",
    description: "error notification when app iframe fails",
  },
  saveConfig: {
    id: '0e/Umt',
    defaultMessage: "Save configuration",
    description: "button to save plugin configuration",
  },
  loadingAppConfiguration: {
    id: 'gO2wDv',
    defaultMessage: "Loading app configuration...",
    description: "loading text while app configuration is being opened",
  },
  loadingPluginConfiguration: {
    id: 'F00IwE',
    defaultMessage: "Loading plugin configuration...",
    description: "loading text while plugin configuration is being opened",
  },
});
